<p-dropdown
  appendTo="body"
  [options]="items"
  [(ngModel)]="selectedSertifikat"
  (onChange)="setSertifikatToHeader()"
>
</p-dropdown>
